/**
 * Created with JetBrains WebStorm.
 * User: cedricGodefroy
 * Date: 28/11/18
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').factory('LaunchDarklyFeatureFlag_Resource', ["$resource", "$location", function ($resource, $location) {
    let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    let resourceLaunchDarklyFeature = $resource(baseUrl + 'rest/launchDarklyFeatureFlag/:flagName', {}, {
        query: {method: 'GET', isArray: true},
        loadByName: {method: 'GET', url: baseUrl + 'rest/launchDarklyFeatureFlag/:flagName'}
    });
    return resourceLaunchDarklyFeature;
}
]);

angular.module('FlexyBeautyApp.services').factory('LaunchDarklyFeatureFlag', ["LaunchDarklyFeatureFlag_Resource", "LaunchDarklyFeatureFlagData", function (LaunchDarklyFeatureFlag_Resource, LaunchDarklyFeatureFlagData) {
    var LaunchDarklyFeatureFlag = function (resource) {
        this.flagName = null;
        this.isActive = false;

        this.loadObject(resource);
        LaunchDarklyFeatureFlagData.add(this);
    };
    LaunchDarklyFeatureFlag.prototype.loadObject = function (object) {
        if (object !== undefined && object != null) {
            this.flagName = object.flagName;
            this.isActive = object.active;
        }
    };

    return LaunchDarklyFeatureFlag;
}
]);

angular.module('FlexyBeautyApp.services').factory('LaunchDarklyFeatureFlagSrv', ["LaunchDarklyFeatureFlag_Resource", "LaunchDarklyFeatureFlag", "LaunchDarklyFeatureFlagData",
    function (LaunchDarklyFeatureFlag_Resource, LaunchDarklyFeatureFlag, LaunchDarklyFeatureFlagData,) {
        var launchDarklyFeatureFlagSrv = {};

        launchDarklyFeatureFlagSrv.query = function (successFunction, errorFunction) {
            LaunchDarklyFeatureFlag_Resource.query(
                {}, //params
                function (data) {   //success
                    LaunchDarklyFeatureFlagData.clear();
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            new LaunchDarklyFeatureFlag(data[i]);//Auto Add to LaunchDarklyFeatureFlagData
                        }

                        LaunchDarklyFeatureFlagData.initFeatureFlags();
                    }

                    if (successFunction !== undefined)
                        successFunction();

                },
                function (data) {
                    if (errorFunction !== undefined)
                        errorFunction(data);
                });
        };

        launchDarklyFeatureFlagSrv.loadFeatureFlag = function (flagName, successFunction, errorFunction) {
            LaunchDarklyFeatureFlag_Resource.loadByName(
                {flagName: flagName},
                function (data) {
                    if (successFunction !== undefined)
                        successFunction(data);
                },
                function (data) {
                    if (errorFunction !== undefined)
                        errorFunction(data);
                });
        };

        return launchDarklyFeatureFlagSrv;
    }
]);

angular.module('FlexyBeautyApp.services').factory('LaunchDarklyFeatureFlagData', ['LaunchDarklyFeatureFlagList', function (LaunchDarklyFeatureFlagList) {
    let launchDarklyFeatureFlagData = {
        featureFlags: [],
        canAccessNewLoading: false,
        canAccessBackofficeCustomer: false,
        canAccessBookingUserStory: false,
        canAccessDoubleTabBlocked: false,
    };

    launchDarklyFeatureFlagData.getByFlagName = function (flagName) {
        for (let i = 0; i < this.featureFlags.length; i++)
            if (this.featureFlags[i].flagName === flagName)
                return this.featureFlags[i];
        return null;
    };

    launchDarklyFeatureFlagData.clear = function () {
        this.featureFlags = [];
    };

    launchDarklyFeatureFlagData.add = function (featureflag) {
        let isFeatureFlagExists = false;
        for (let i = 0; i < this.featureFlags.length; i++) {
            if (this.featureFlags.flagName === featureflag.flagName) {
                isFeatureFlagExists = true;
            }
        }
        if (!isFeatureFlagExists) {
            this.featureFlags.push(featureflag);
        }
    };

    launchDarklyFeatureFlagData.getFeatureFlagList = function () {
        return this.featureFlags;
    };

    launchDarklyFeatureFlagData.initFeatureFlags = function () {
        const newLoadingFeatureFlag = this.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_3775_FEATURE_FLAG_NEW_LOADING.flagName);
        launchDarklyFeatureFlagData.canAccessNewLoading = (newLoadingFeatureFlag ? newLoadingFeatureFlag.isActive : false);

        const canAccessBackofficeCustomerFlag = this.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_3279_FEATURE_FLAG_BACKOFFICE_CUSTOMER.flagName);
        launchDarklyFeatureFlagData.canAccessBackofficeCustomer = (canAccessBackofficeCustomerFlag ? canAccessBackofficeCustomerFlag.isActive : false);

        const canAccessBookingUserStoryFlag = this.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_4365_FEATURE_FLAG_BOOKING_USER_STORY.flagName);
        launchDarklyFeatureFlagData.canAccessBookingUserStory = (canAccessBookingUserStoryFlag ? canAccessBookingUserStoryFlag.isActive : false);

        const canAccessKiuteProAppFlag = this.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_4424_FEATURE_FLAG_KIUTE_PRO_APP.flagName);
        launchDarklyFeatureFlagData.canAccessKiuteProApp = (canAccessKiuteProAppFlag ? canAccessKiuteProAppFlag.isActive : false);

        const canAccessDoubleTabBlocked = this.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_287_DOUBLE_TAB_BLOCKED.flagName);
        launchDarklyFeatureFlagData.canAccessDoubleTabBlocked = (canAccessDoubleTabBlocked ? canAccessDoubleTabBlocked.isActive : false);

        const forceMigrationInfosFlag = this.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_311_FORCE_MIGRATION_INFOS.flagName);
        launchDarklyFeatureFlagData.forceMigrationInfos = (forceMigrationInfosFlag ? forceMigrationInfosFlag.isActive : false);

        const forceMigrationDateFlag = this.getByFlagName(LaunchDarklyFeatureFlagList.FLEX_364_FORCE_MIGRATION_DATE.flagName);
        launchDarklyFeatureFlagData.forceMigrationDate = (forceMigrationDateFlag ? forceMigrationDateFlag.isActive : false);
    };

    return launchDarklyFeatureFlagData;
}
]);



// WEBPACK FOOTER //
// ./js/services/models/LaunchDarklyFeatureFlag.js